module.exports = __webpack_public_path__ + "img/blue-rectangle-table-10.36c46274.png";